import React, { useState, useEffect } from "react";
import {
    Grid,
    Checkbox,
    TextareaAutosize,
    Typography,
    Button,
    List,
    ListItem
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import PageHeader from "../../../Components/PageHeader";

/** Local party dependencies & Libraries */
import Services from '../../../Services';
import Snackbar from '../../../Components/Snackbar';
import { helpers } from "../../../helpers";
import { paths } from "../Application/path";
import { Input, Modal } from "antd";
import { formatSSN } from "../../../helpers/textValidation";
import SidebarApplicants from "../../../Components/SidebarApplicants";


const {
    users,
    Storage,
    hr
} = Services;

const {
    showSnackBar,
} = helpers;


// const GFG_Fun = () => {
//     var file = document.getElementById("i9");
//     if(file.files.length === 0 ){
//         var element = document.getElementById("i9");
//         element.classList.add("NotSelected");
//     } else {
//         var element = document.getElementById("i9");
//         element.classList.add("FileSelected");
//     }
// }
const DocumentsStep3 = (props) => {

    const history = useHistory();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formsPosted, setFormsPosted] = useState(false);
    const [ssnInput, setSsnInput] = useState(null)
    const [ssn, setssn] = useState(null)
    const [formsInfo, setFormsInfo] = useState([])
    const [SaveFlag, setSaveFlag] = useState(false)
    // let formIDs = [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 18, 19, 20]
    let formIDs = [5, 6, 7, 8, 9, 11, 12, 13, 14, 18, 20]



    var step3FormPosted = new BroadcastChannel('step3form_posted');

    step3FormPosted.onmessage = ($e) => {
        const { data = {} } = $e;
        const { topic, message } = data;
        switch (topic) {
            case 'form-updated':
                toggleFormsPosted();
                break;
            default:
                break;
        }
    }

    const toggleFormsPosted = () => {
        setFormsPosted(true);
        setTimeout(setFormsPosted.bind(null, false), 0);
        showSnackBar('Form posted');
    }

    const saveAndContinue = async () => {
        try {
            const formData = new FormData();

            if (files?.w4?.length)
                formData.append('W4', files.w4[0]);
            if (files?.i9?.length)
                formData.append('I9', files.i9[0]);
            if (files?.disa?.length)
                formData.append('DISA', files.disa[0]);
            if (files?.ssn?.length)
                formData.append('SSN', files.ssn[0]);
            formData.append('ssn', ssnInput);

            const response = await users.postStep3(
                formData,
                {
                    'Content-Type': 'multipart/form-data'
                }
            )

            localStorage.setItem('user_profile', JSON.stringify(response?.data));
            const user_profile = JSON.parse(storage.get('user_profile'));
            history.push({
                pathname: '/hr-2nd-approval',
                state: {
                    approved: true,
                    step: 1,
                    applyToStorage: {
                        user_profile: {
                            ...user_profile,
                            EmployeeStatusId: 6,
                        }
                    }
                }
            });
        } catch (exc) {

        }
    }

    const storage = new Storage();

    const [files, filesSetter] = useState({
        i9: null,
        disa: null,
        w4: null,
        ssn: null
    })



    const fetchFilledForms = async (user) => {
        const response = await hr.getAllApplicantsByIDApplicantLogin({ id: user?.id }, { Authorization: localStorage.getItem("access_jwt") })
        setFormsInfo(response?.data?.form?.rows?.map(form => form?.ApplicantFormId))
        if (!response?.employee?.ssn) setIsModalOpen(true)
        setssn(response?.employee?.ssn)
    }



    useEffect(() => {
        window.scrollTo(0, 0);
        let user = JSON.parse(localStorage.getItem('user_profile'));
        if (user) {
            var { ApplicantStatusId } = user;

            if (props.status !== ApplicantStatusId)
                history.push({
                    pathname: paths[ApplicantStatusId],
                    state: {
                        approved: false,
                        step: 1,
                        applyToStorage: {
                            user_profile: {
                                ...user,
                                EmployeeStatusId: 6,
                            }
                        }
                    }
                });
        }
        fetchFilledForms(user)

    }, [formsPosted])



    const storeFile = (prop, $e) => {
        const {
            target: { files: uploadedFiles }
        } = $e;

        filesSetter({ ...files, [prop]: uploadedFiles });
    }


    const triggerInput = (id, $e) => {
        const ev = $e || window.event;
        const element = document.getElementById(id);
        ev.stopPropagation();
        return false;
    }


    const handleSSNFormatting = (value) => {

        let formattedNumber = formatSSN(value)
        setSsnInput(formattedNumber)
        // form.setFieldsValue({ ssn: formattedNumber })
    }

    const handleOk = async () => {

        if (!ssnInput) return showSnackBar("SSN field is required")
        if (ssnInput?.replace(/-/g, '')?.length < 9) {
            showSnackBar("Please enter valid SSN")
            return
        }
        let body = {
            ssn: ssnInput?.replace(/-/g, '')
        }
        let response = await users?.onSSNSubmit(
            body,
            {
                'content-type': 'application/json',
            }
        )
        if (response?.httpStatus === 200) {
            setssn(body?.ssn)
            setIsModalOpen(false)
            return
        }
        else showSnackBar(response?.message)
    }


    return (
        <Grid container xs={12} className="Liq-Container HRPortal">
            <Modal open={isModalOpen} onOk={handleOk} footer={false} title={false} closable={false} closeIcon={<></>}>
                <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", justifyContent: "center" }}>
                    <p
                        style={{ fontSize: '16px', marginBottom: "0" }}>
                        Please Enter Your SSN
                    </p>
                    <Input onChange={
                        (e) => handleSSNFormatting(e.target.value)
                    } maxLength={11} minLength={11} placeholder='123-45-6789' value={ssnInput} className=' input-style' style={{ width: "100%", padding: "10px" }} required={true} />
                    <button
                        className='btn-modal'
                        style={{ background: '#2963AD', width: '50%', color: 'white', height: '40px', borderRadius: '10px', border: 'none', cursor: "pointer" }}
                        onClick={handleOk}>
                        Submit
                    </button>
                </div>
            </Modal>
            <Grid xs={12} md={2} className="LeftContol" id="LeftContol">
                <SidebarApplicants />
            </Grid>
            <Grid xs={12} md={10} container justify="center" className="PageContent">
                <Grid className="PagesFrame">
                    <PageHeader />
                    <Grid id="PageTitle" className="f16">Complete Onboarding Document</Grid>
                    {/* Page Start */}
                    <Grid xs={12} className="ContentPage ApplicantForms">
                        <Grid xs={12} className="StepsLine Step2Line Step3Line">
                            <List>
                                <ListItem className="StepComplete">Step 1</ListItem>
                                <ListItem className="StepComplete">Step 2</ListItem>
                                <ListItem className="StepComplete">Step 3</ListItem>
                                {/* <ListItem >Step 4</ListItem> */}
                            </List>
                        </Grid>
                        <Grid xs={12} >
                            <Grid xs={12} >
                                <div>
                                    <Typography variant="h1" component="h2" className="bold f16">
                                        You're required to fill out the following documents to complete your application
                                    </Typography>
                                    <Typography variant="h1" component="h2" className="bold f16 mt40">
                                        Section 3
                                    </Typography>
                                </div>

                                <div style={{ display: "flex", flexWrap: "wrap", gap: "15px", width: "100%" }}>
                                    <Link to="/documents/conditional-offer" target="_blank" className={`DocDownload ${formsInfo?.includes(5) && 'disabled-link'}`}>
                                        <Grid className="FileName">
                                            Conditional Offer
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(5)
                                                ? ''
                                                : 'graytick'
                                        }></Button>
                                    </Link>
                                    <Link to="/documents/post-conditional-job-offer" target="_blank" className={`DocDownload ${formsInfo?.includes(6) && 'disabled-link'}`}>
                                        <Grid className="FileName">
                                            Post Conditional Job offer Question
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(6)
                                                ? ''
                                                : 'graytick'
                                        }></Button>
                                    </Link>
                                    <Link to="/documents/fuel-card-agreement" target="_blank" className={`DocDownload ${formsInfo?.includes(7) && 'disabled-link'}`}>
                                        <Grid className="FileName">
                                            Fuel Card Agreement
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(7)
                                                ? ''
                                                : 'graytick'
                                        }></Button>
                                    </Link>
                                    <Link to="/documents/boot-card-agreement" target="_blank" className={`DocDownload ${formsInfo?.includes(8) && 'disabled-link'}`}>
                                        <Grid className="FileName">
                                            Boot Cost Agreement
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(8)
                                                ? ''
                                                : 'graytick'
                                        }></Button>
                                    </Link>
                                    <Link to="/documents/twic-card-payment-agreement" target="_blank" className={`DocDownload ${formsInfo?.includes(9) && 'disabled-link'}`}>
                                        <Grid className="FileName">
                                            TWIC Card Payment Agreement
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(9)
                                                ? ''
                                                : 'graytick'
                                        }></Button>
                                    </Link>
                                    <Link to="/documents/employee-agreement" target="_blank" className={`DocDownload ${formsInfo?.includes(13) && "disabled-link"}`}>
                                        <Grid className="FileName">
                                            Employment Agreement
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(13)
                                                ? ''
                                                : 'graytick'
                                        }
                                        ></Button>
                                    </Link>
                                    <Link to="/documents/harassment" target="_blank" className={`DocDownload ${formsInfo?.includes(14) && "disabled-link"}`}>
                                        <Grid className="FileName">
                                            TGS Harassment
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(14)
                                                ? ''
                                                : 'graytick'
                                        }></Button>
                                    </Link>
                                    {/* <Link to="/documents/direct-deposit" target="_blank" className={`DocDownload ${storage.get('step-3-form-directDeposit') && 'disabled-link'}`}>
                                    <Grid className="FileName">
                                        Direct Deposit
                                    </Grid>
                                    <Button className={
                                        storage.get('step-3-form-directDeposit')
                                            ? ''
                                            : 'graytick'
                                    }></Button>
                                </Link> */}
                                    {/* <Link to="/documents/depositeform" target="_blank" className={`DocDownload ${formsInfo?.includes(10) && 'disabled-link'}`}>
                                        <Grid className="FileName">
                                            Direct Deposit
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(10)
                                                ? ''
                                                : 'graytick'
                                        }></Button>
                                    </Link> */}
                                    <Link to="/documents/fcra" target="_blank" className={`DocDownload ${formsInfo?.includes(11) && 'disabled-link'}`}>
                                        <Grid className="FileName">
                                            FCRA
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(11)
                                                ? ''
                                                : 'graytick'
                                        }></Button>
                                    </Link>

                                    <Link to="/documents/companyPropertyReturn" target="_blank" className={`DocDownload ${formsInfo?.includes(20) && 'disabled-link'}`}>
                                        <Grid className="FileName">
                                            Company Propety Return
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(20)
                                                ? ''
                                                : 'graytick'
                                        }></Button>
                                    </Link>



                                    <Link to="/documents/arbitration-agreement" target="_blank" className={`DocDownload ${formsInfo?.includes(12) && 'disabled-link'}`}>
                                        <Grid className="FileName">
                                            Arbitration Agreement
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(12)
                                                ? ''
                                                : 'graytick'
                                        }></Button>
                                    </Link>
                                    <Link to="/documents/driver-information" target="_blank" className={`DocDownload ${formsInfo?.includes(18) && 'disabled-link'}`}>
                                        <Grid className="FileName">
                                            Driver Information Form
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(18)
                                                ? ''
                                                : 'graytick'
                                        }></Button>
                                    </Link>
                                    {/* <Link to="/documents/ReleaseAndDocumentation" target="_blank" className={`DocDownload ${formsInfo?.includes(19) && 'disabled-link'}`}>
                                        <Grid className="FileName">
                                            Release And Documentation
                                        </Grid>
                                        <Button className={
                                            formsInfo?.includes(19)
                                                ? ''
                                                : 'graytick'
                                        }></Button>
                                    </Link> */}
                                </div>

                                <Typography variant="h1" component="h2" className="bold f16 mt40">
                                    Download I-9, W-4 and DISA Forms here
                                </Typography>

                                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", width: "100%" }}>
                                    <a href="/assets/forms/I-9.pdf" target="blank" className="PDFDownload">
                                        <Grid className="FileName"  >
                                            I-9 Forms
                                        </Grid>
                                        <Button></Button>
                                    </a>
                                    <a href="/assets/forms/w4_2024.pdf" target="blank" className="PDFDownload">
                                        <Grid className="FileName">
                                            W-4 Forms
                                        </Grid>
                                        <Button></Button>
                                    </a>
                                    <a href="/assets/forms/DISA_Final.pdf" target="blank" className="PDFDownload">
                                        <Grid className="FileName">
                                            DISA Forms
                                        </Grid>
                                        <Button></Button>
                                    </a>
                                </div>
                                <div>
                                    <Typography variant="h6" className="MuiTypography-subtitle2 MuiTypography-colorTextSecondary" component="h6" style={{ marginTop: "30px" }}>
                                        Please ensure you have signed the documents before uploading them
                                    </Typography>
                                    <a href="/assets/forms/Zipped.zip" target="_blank" className="ZipFile">
                                        <Grid className="FileName">
                                            All PDF ZIP Files
                                        </Grid>
                                        <Button></Button>
                                    </a>
                                    <Typography variant="h6" className="MuiTypography-subtitle2 MuiTypography-colorTextSecondary" component="h6">
                                        Only for HR
                                    </Typography>
                                </div>

                                <Typography variant="h1" component="h2" className="bold f16 mt40">
                                    Please upload the I-9, W-4 and DISA forms and ensure that the forms are filled out clearly in block letters using a black or blue pen.
                                </Typography>

                                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", width: "100%" }}>

                                    <label for="i9" className={
                                        'i9 UploadFile' + (
                                            files.i9
                                                ? ' active'
                                                : ''
                                        )
                                    }
                                        onClick={triggerInput.bind(null, 'i9')}>
                                        <Grid className="FileName">
                                            Upload I-9 Form Here
                                        </Grid>
                                        <Button></Button>
                                    </label>
                                    <input type="file" id="i9" className="hide" required={false}
                                        onChange={storeFile.bind(null, 'i9')} />
                                    <label for="w4" className={
                                        'w4f UploadFile' + (
                                            files.w4
                                                ? ' active'
                                                : ''
                                        )

                                    }
                                        onClick={triggerInput.bind(null, 'w4')}>
                                        <Grid className="FileName">
                                            Upload W-4 Form Here
                                        </Grid>
                                        <Button></Button>
                                    </label>
                                    <input type="file" id="w4" className="hide"
                                        onChange={storeFile.bind(null, 'w4')} required={false} />
                                    <label for="disa" className={
                                        'disa UploadFile' + (
                                            files.disa
                                                ? ' active'
                                                : ''
                                        )
                                    }
                                        onClick={triggerInput.bind(null, 'disa')}>
                                        <Grid className="FileName">
                                            Upload DISA Form Here
                                        </Grid>
                                        <Button></Button>
                                    </label>
                                    <input type="file" id="disa" className="hide"
                                        onChange={storeFile.bind(null, 'disa')} required={false} />

                                </div>

                                <div style={{ display: "grid", gridTemplateColumns: "50% 50%", gap: "10px", width: "100%" }}>
                                    <div>

                                        <Typography variant="h1" component="h2" className="bold f16 mt40">
                                            Please upload your Social Security Card
                                        </Typography>
                                        <label for="ssn" className={
                                            'ssn UploadFile' + (
                                                files.ssn
                                                    ? ' active'
                                                    : ''
                                            )
                                        }
                                            onClick={triggerInput.bind(null, 'ssn')}>
                                            <Grid className="FileName">
                                                Upload SSN Here
                                            </Grid>
                                            <Button></Button>
                                        </label>
                                        <input type="file" id="ssn" className="hide" onChange={storeFile.bind(null, 'ssn')} required={false} />
                                    </div>


                                </div>

                            </Grid>
                            <Grid xs={12} className="mt50">
                                <Grid xs={12} md={8} lg={6} container justify="space-between">
                                    {/* <Link to="/documents" className="LinkButtonBack">Back</Link> */}
                                    <button
                                        className="LinkButton"
                                        disabled={!formIDs?.every(i => formsInfo?.includes(i))}
                                        onClick={saveAndContinue}>Save & Continue</button>
                                    <Snackbar
                                    ></Snackbar>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* Page Start End */}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default DocumentsStep3;
